import { useLang } from "@/lib/i18n";
import { useStore } from "@/lib/store";

export const Totals = ({ quote, children }) => {
  const { t, money } = useLang();
  const { settings } = useStore();
  const left = settings ? settings.free_shipping_over - quote.subtotal : 0;
  return (
    <div className="panel p-6" data-testid="order-totals">
      <div className="flex justify-between py-1.5 text-slate-300"><span>{t("cart.subtotal")}</span><span className="font-mono-num" data-testid="totals-subtotal">{money(quote.subtotal)}</span></div>
      <div className="flex justify-between py-1.5 text-slate-300">
        <span>{t("cart.shipping")}</span>
        <span className="font-mono-num" data-testid="totals-shipping">{quote.shipping === 0 ? t("cart.free") : money(quote.shipping)}</span>
      </div>
      <p className={`mt-1 text-xs font-bold ${left >= 0 ? "text-fire" : "text-emerald-400"}`} data-testid="free-shipping-note">
        {left >= 0 ? t("cart.free_left", { amt: money(left + 0.01) }) : t("cart.free_got")}
      </p>
      <div className="mt-4 flex items-baseline justify-between border-t border-white/10 pt-4">
        <span className="font-extrabold">{t("cart.total")}</span>
        <span className="font-display text-3xl text-gold" data-testid="totals-total">{money(quote.total)}</span>
      </div>
      <p className="mt-2 text-xs text-slate-500">{t("cart.tax_note")}</p>
      {children}
    </div>
  );
};
